import { createSelector } from '@app/utils/createSelector'

import type { ApiDocument } from '@app/packages/api/v2/types/entities'
import type { PostDocumentsRequest } from '@app/packages/api/v2/types/params'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { createReduxSlice } from '@app/store/redux_slice'
import { profileUserResultSelector } from '@app/store/selectors/profile'
import { createThunk } from '@app/store/thunk'

import { routingUUIDSelector } from './routing'

const slice = createReduxSlice<SliceState<ApiDocument[]>>('documents')

export const uploadDocument = (request: PostDocumentsRequest) =>
  createThunk(async dispatch => {
    const [{ postDocuments }, { callV2Api }] = await Promise.all([import('@app/packages/api/v2/actions/documents'), import('@app/store/actions/api')])
    const resp = await dispatch(callV2Api(postDocuments(request)))
    dispatch(slice.update(state => (state ? { ...state, data: [...state.data, resp.data] } : state)))
  })

export const documentsSelector = createSelector([routingUUIDSelector, profileUserResultSelector, slice.selector], (uuid, profileResult, sliceData) =>
  createLoadable(c => {
    const profile = c.unwrap(profileResult)
    if (profile?.account_type !== 'sitter') return []
    const hash = [uuid, profile?.id || 'guest'].join(':')
    return withCheckedSliceState(c, {
      sliceState: sliceData,
      slice,
      hash,
      load: async dispatch => {
        const [{ getDocuments }, { callV2Api }] = await Promise.all([import('@app/packages/api/v2/actions/documents'), import('@app/store/actions/api')])
        const resp = await dispatch(callV2Api(getDocuments()))
        return resp.data
      },
    })
  })
)
